// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2nC22","inputWrap":"Table_inputWrap__2Z3Hc","col":"Table_col__3BNUx","bmiTooltip":"Table_bmiTooltip__3-RlP"};